module.exports = __webpack_public_path__ + "img/sixpackcarrier08.0cdf29c4.jpg";